<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect" id="elMenu" >
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/niZhouIndex">首页</el-menu-item>
        <el-menu-item index="/niZhou/gasClamp">主缆进排气</el-menu-item>
        <!-- <el-submenu index="/niZhou/bridgeImg">
          <template slot="title">制备站</template> -->
        <el-submenu index="/niZhou/prepStation1">
          <template slot="title">1号制备站</template>
          <el-menu-item index="/niZhou/prepStation1/anchorAfan">1号制备站</el-menu-item>
          <el-menu-item index="/niZhou/prepStation1/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation1/dehumidifierTwo">2号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/niZhou/prepStation2">
          <template slot="title">2号制备站</template>
          <el-menu-item index="/niZhou/prepStation2/anchorAfan">2号制备站</el-menu-item>
          <el-menu-item index="/niZhou/prepStation2/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation2/dehumidifierTwo">2号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/niZhou/prepStation3">
          <template slot="title">3号制备站</template>
          <el-menu-item index="/niZhou/prepStation3/anchorAfan">3号制备站</el-menu-item>
          <el-menu-item index="/niZhou/prepStation3/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation3/dehumidifierTwo">2号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation3/highPressureFanLess">高压风机</el-menu-item>
        </el-submenu>
        <el-submenu index="/niZhou/prepStation4">
          <template slot="title">4号制备站</template>
          <el-menu-item index="/niZhou/prepStation4/anchorAfan">4号制备站</el-menu-item>
          <el-menu-item index="/niZhou/prepStation4/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation4/dehumidifierTwo">2号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation4/highPressureFanLess">高压风机</el-menu-item>
        </el-submenu>
        <el-submenu index="/niZhou/prepStation5">
          <template slot="title">5号制备站</template>
          <el-menu-item index="/niZhou/prepStation5/prepStationBig">5号制备站</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/dehumidifierTwo">2号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/dehumidifierThree">3号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/circulatingFan">循环风机和换热器</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/boxGirder">箱梁</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/highPressureFan12">高压风机 1-2号</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/highPressureFan34">高压风机 3-4号</el-menu-item>
          <el-menu-item index="/niZhou/prepStation5/highPressureFan56">高压风机 5-6号</el-menu-item>
        </el-submenu>
        <el-submenu index="/niZhou/prepStation6">
          <template slot="title">6号制备站</template>
          <el-menu-item index="/niZhou/prepStation6/prepStationBig">6号制备站</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/dehumidifierOne">1号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/dehumidifierTwo">2号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/dehumidifierThree">3号除湿机</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/circulatingFan">循环风机和换热器</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/boxGirder">箱梁</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/highPressureFan12">高压风机 1-2号</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/highPressureFan34">高压风机 3-4号</el-menu-item>
          <el-menu-item index="/niZhou/prepStation6/highPressureFan56">高压风机 5-6号</el-menu-item>
        </el-submenu>
        <!-- </el-submenu> -->
        <el-menu-item index="/niZhou/bridgeImg">全桥除湿总体布置图</el-menu-item>

        <el-submenu
          index="
            /niZhou/dataHistory?bridgeId=ffaa13fe-473e-4827-a8fd-b89b8fdd3899&scenarioId=TBD'
          "
        >
          <template slot="title">数据历史</template>
          <el-menu-item index="/niZhou/dataHistory?bridgeId=ffaa13fe-473e-4827-a8fd-b89b8fdd3899&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/niZhou/dataHistory?bridgeId=ffaa13fe-473e-4827-a8fd-b89b8fdd3899"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="GUANGDONG" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="ni-zhou">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "nizhou",
  data() {
    return {
      bridgeId: "ffaa13fe-473e-4827-a8fd-b89b8fdd3899",
      envInfo: {
        envId: "57c98e21-2072-4fac-a64c-f5b26b363b55",
        weather: "2f878ffb-fdcd-42ff-9bc0-23066f4d2da8",
        humidity: "1ea81f0c-3a6b-4d05-8dfa-815e6f8d7a92",
        temperature: "5373a7ed-0077-4565-933b-782b8d87558a",
      },
      id2Path: {
        "a1ffe3e8-6462-423b-af3f-b2259954e45e": "nizhou/prepStation1",
        "d56a93e9-6708-4727-9569-e7332bb84728": "nizhou/prepStation2",
        "922e3911-5b36-4bc3-8d57-cc0aca6aa459": "nizhou/prepStation3",
        "070856c3-2a7a-49a7-849e-e9a4eaaa1ed0": "nizhou/prepStation4",
        "f3fca3ce-b7fc-4c0d-8e42-7034df6965de": "nizhou/prepStation5",
        "d3baafbf-08aa-4a4e-a1c5-7ed2906de97d": "nizhou/prepStation6",
        "69259224-b365-4f62-ae96-e52fc31b2f00": "nizhou/prepStation6",
        "25a74940-1a2a-41a4-aca0-c1a09f57e928": "niZhou/gasClamp",
      },
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

      document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

 <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>